import { get } from 'axios'
export default {
    actions: {
        retrieve(ctx) {
            if (ctx.state.cityLoadStatus) return;
            return get('/api/cities').then(response => {
                ctx.commit('setCities', response.data.Data)
                ctx.commit('changeCityLoadStatus', true)
            }).catch((reason) => console.error(reason))
        }
    },
    state: {
        cityLoadStatus: false,
        cities: [],
    },
    mutations: {
        changeCityLoadStatus(state, status) {
            state.cityLoadStatus = status
        },
        setCities(state, cities) {
            state.cities = cities
        }
    },
    getters: {
        cities(state) {
            return state.cities
        }
    }

}